const defaultCurrency = (format?: Intl.NumberFormatOptions) =>
  new Intl.NumberFormat(undefined, {
    ...format,
    style: 'currency',
    currency: 'USD'
  });

export const formatCurrency = defaultCurrency().format;

export const formatCurrencyCompact = defaultCurrency({ notation: 'compact' }).format;
